import React, { useState, useEffect } from "react";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  FormGroup,
  CustomInput,
} from "reactstrap";

import style from "./styles.module.scss";
import { FormSelect } from "../Controls";
import { FormField } from "../../..";

const initialFields = {
  DataProviderId: "",
  DataProviderName: "",
  AssetProviderName: "",
  AssetProviderTradePricing: false,
  AssetProviderAccountingPricing: false,
};

const ModalSinonyms = ({ open, toggle, services, synonym, dataProviders, onConfirm }) => {
  const [fields, setFields] = useState(initialFields);
  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (synonym) {
      setFields(synonym);
    } else {
      setFields(initialFields);
    }
  }, [synonym]);

  const onChange = (name, value) => {
    setFields({ ...fields, [name]: value });
    setErrors({ ...errors, [name]: undefined });
  };

  const handleSave = async () => {
    const errors = validate(fields);

    if (Object.keys(errors).length == 0) {
      setLoading(true);
      const dataProvider = dataProviders.find((dp) => dp.DataProviderId == fields.DataProviderId);
      const result = await onConfirm({ ...fields, ...dataProvider });
      setLoading(false);

      if (result == 200) {
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={open} toggle={toggle} className={style.modal}>
      <ModalHeader toggle={toggle}>{synonym ? "Edit Sinonym" : "Add Sinonym"}</ModalHeader>
      <ModalBody>
        {dataProviders ? (
          <FormSelect
            name="DataProviderId"
            label="Data provider"
            selectItems={dataProviders}
            getSelectItemId={(i) => i.DataProviderId}
            getSelectItemName={(i) => i.DataProviderName}
            value={fields.DataProviderId}
            disabled={synonym ? true : false}
            onChange={onChange}
          />
        ) : (
          <Spinner size="sm" />
        )}

        <FormField
          name="AssetProviderName"
          label="Asset Provider Name"
          value={fields.AssetProviderName}
          onChange={onChange}
        />

        <FormGroup>
          <CustomInput
            label="Trade Pricing"
            id="AssetProviderTradePricing"
            type="checkbox"
            checked={fields.AssetProviderTradePricing}
            onChange={(e) => onChange("AssetProviderTradePricing", e.target.checked)}
          />
        </FormGroup>

        <FormGroup>
          <CustomInput
            label="Accounting Pricing"
            id="AssetProviderAccountingPricing"
            type="checkbox"
            checked={fields.AssetProviderAccountingPricing}
            onChange={(e) => onChange("AssetProviderAccountingPricing", e.target.checked)}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary pl-3 pr-3"
          loading={loading}
          disabled={false}
          onClick={() => handleSave()}
          data-style={SLIDE_LEFT}
        >
          <i className="fa fa-floppy-o mr-1" aria-hidden="true"></i>
          Save
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

function validate(fields) {
  Object.entries(fields).forEach(([name, value]) => {});

  return {};
}

export default ModalSinonyms;
